import { render, staticRenderFns } from "./search.vue?vue&type=template&id=45a5590c&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=45a5590c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a5590c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a5590c')) {
      api.createRecord('45a5590c', component.options)
    } else {
      api.reload('45a5590c', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=45a5590c&scoped=true", function () {
      api.rerender('45a5590c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/upgradePopupManage/components/search.vue"
export default component.exports